// extracted by mini-css-extract-plugin
module.exports = {"container":"DrawPile_container__3KfTk","pile":"DrawPile_pile__mDmp9","policy":"DrawPile_policy__7FW-U","badge":"DrawPile_badge__3YvQZ"};